// src/layouts/Pages/PageHeader/CardHeaderColumns/items/ageFounded.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { CalendarOutlined } from '@ant-design/icons';
import { getAgeDisplay } from 'utils/date';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const ageFoundedItem = record => {
  const isCompany = !!(record?.cnpj?.value || record?.foundedAt);
  const date = record?.birthdate || record?.foundedAt;
  const age = date && getAgeDisplay(date);

  return {
    key: 'age',
    icon: <CalendarOutlined />,
    label: age?.label,
    tooltipText: translateX(isCompany ? 'founded_at' : 'age'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default ageFoundedItem;
